// :: Filters

import moment from "moment";

// :: currency
// :: Transforms the number into MXN currency
export const currencyFilter = value => {
  const formatter = new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: "MXN",
    minimumFractionDigits: 0
  });
  return formatter.format(value);
};

// :: currency without dollar sign
// :: Transforms the number into MXN currency
export const currencyDecimalFilter = value => {
  const formatter = new Intl.NumberFormat("es-MX", {
    style: "decimal",
    currency: "MXN",
    minimumFractionDigits: 2
  });
  return formatter.format(value);
};

// :: number with thousands separator
// :: Transforms the number into a comma separated string
export const thousandsNumberFilter = value => {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

// :: date stirng
// :: Transforms a Date into a short string ddMMMMYYYY
export const shortDateStringFilter = value => {
  moment.locale("es");
  return moment(value).format("DD MMMM YYYY");
};

// :: date stirng
// :: Transforms a Date into a short string dd/MM/YY
export const shortDateNumbersStringFilter = value => {
  moment.locale("es");
  return moment(value).format("L");
};
// :: Transforms a Date into a short string dd/MM/YY
export const largeDateNumbersStringFilter = value => {
  moment.locale("es");
  return moment(value).format("MMMM Do YYYY, h:mm:ss a");
};

// :: remove aditional decimal places
export const oneDecimal = value => {
  return value.toFixed(1);
};

export const lowerCaseName = value => {
  if (value) return value.toLowerCase().substring(0, value.lastIndexOf(" "));
  else return "";
};
